import React from "react";
import { Card } from "react-bootstrap";
import MainCard from "../../../Components/Cards/MainCard";

const ForecastingCard = ({ kpiData, cardConfig }) => {
  // console.log(kpiData);
  const { icon, iconColor } = cardConfig;
  return (
    <MainCard>
      <Card.Body className="d-flex justify-content-start p-0">
        <div className="d-flex justify-content-start  align-items-center mb-3">
          <div className={`p-2 rounded  ${iconColor}`}>{icon}</div>
        </div>
        <div className="d-flex flex-column">
          <h3 className="fw-bold text-dark mb-1">{kpiData.value}</h3>

          <p className="text-muted small mb-0">{kpiData.title}</p>
        </div>
      </Card.Body>
    </MainCard>
  );
};

export default ForecastingCard;
